"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimestamp = exports.getAriaLabel = void 0;
var _videoText = _interopRequireDefault(require("../../Video/videoText"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getTimestamp = (videoLength, copy) => {
  const minutes = Math.floor(videoLength / 60);
  const seconds = Math.ceil(videoLength % 60);
  const minutesText = minutes > 0 ? `${minutes}min ` : '';
  const secondsText = `${seconds}${copy === 'fr' ? 's' : 'sec'}`;
  const timestamp = `${minutesText}${secondsText}`;
  return {
    minutes,
    seconds,
    timestamp
  };
};
exports.getTimestamp = getTimestamp;
const getAriaLabel = (timestamp, copy) => {
  const {
    minutes,
    seconds
  } = timestamp;
  const text = _videoText.default[copy];
  const minutesText = `${minutes} ${minutes !== 1 ? text.minutes : text.minute}`;
  const secondsText = `${seconds} ${seconds !== 1 ? text.seconds : text.second}`;
  return text.ariaLabel.replace('{minutes}', minutesText).replace('{seconds}', secondsText);
};
exports.getAriaLabel = getAriaLabel;